export default __webpack_public_path__ + "static/m-portfolio2-b4d9725c7d7b94e703c0c125284e1c9e.jpg";